import { createClient, type SupabaseClient } from '@supabase/supabase-js'

export function createSupabaseClient(url: string, anonKey: string): SupabaseClient {
  // Fonctions serveur non typées ici : chaque réponse est validée par les schémas de @groupe-reca/contracts.
  return createClient<never>(url, anonKey, {
    auth: { persistSession: true, autoRefreshToken: true, storageKey: 'reca-operator-v3-auth' },
  })
}

/** Erreur métier (`raise exception using message = 'CODE'`) d'un appel de fonction serveur. */
export class ServerCommandError extends Error {
  constructor(
    public readonly code: string,
    public readonly detail?: string,
  ) {
    super(code)
    this.name = 'ServerCommandError'
  }
}

/** Le serveur n'a pas pu répondre (réseau, délai) : le résultat est inconnu. */
export class UncertainResultError extends Error {
  constructor() {
    super('UNCERTAIN_RESULT')
    this.name = 'UncertainResultError'
  }
}

interface RpcResponse {
  data: unknown
  error: { message: string; details?: string | null; code?: string } | null
}

export async function callRpc(client: SupabaseClient, name: string, args?: Record<string, unknown>): Promise<unknown> {
  let response: RpcResponse
  try {
    response = await client.rpc(name, args)
  } catch {
    throw new UncertainResultError()
  }
  if (response.error) {
    const message = response.error.message.trim()
    // Une erreur réseau (fetch échoué) n'a pas de code métier : le résultat est inconnu.
    if (/^[A-Z][A-Z_]+$/.test(message)) throw new ServerCommandError(message, response.error.details ?? undefined)
    throw new UncertainResultError()
  }
  return response.data
}
